import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useServices } from '../../../../core/contexts/useServices';

export const DEAD_LETTERS_QUERY_KEY = ['dead-letters'] as const;
export const deadLetterDetailKey = (id: number) => ['dead-letters', id] as const;

export function useDeadLetterMessages() {
  const { deadLetterService } = useServices();
  return useQuery({
    queryKey: DEAD_LETTERS_QUERY_KEY,
    queryFn: () => deadLetterService.getAll(),
  });
}

export function useDeadLetterDetail(id: number | null) {
  const { deadLetterService } = useServices();
  return useQuery({
    queryKey: deadLetterDetailKey(id ?? 0),
    queryFn: () => deadLetterService.show(id!),
    enabled: id !== null,
  });
}

export function useRetryDeadLetter() {
  const { deadLetterService } = useServices();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => deadLetterService.retry(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: DEAD_LETTERS_QUERY_KEY });
    },
  });
}

export function useRemoveDeadLetter() {
  const { deadLetterService } = useServices();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => deadLetterService.remove(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: DEAD_LETTERS_QUERY_KEY });
    },
  });
}
